import { Kaggle, usersClient } from "../sdk";

export const mockUserClient = () => {
  usersClient.usersService.followUser = () => Promise.resolve({});

  usersClient.usersService.unfollowUser = () => Promise.resolve({});

  usersClient.profileService.getProfilePreview = () =>
    Promise.resolve({
      userName: "Bojan",
      displayName: "Bojan Tunguz",
      profileUrl: "/tunguz",
      thumbnailUrl:
        "https://storage.googleapis.com/kaggle-avatars/images/417337-fb.jpg",
      performanceTier: 4,
      country: "United States",
      region: "Indiana",
      city: "Greencastle",
      occupation: "Data Scientist at Nvidia (Rapids.ai)",
      isFollowing: true,
    });

  usersClient.getUser = () =>
    Promise.resolve({
      id: null,
      displayName: "Bojan",
      email: null,
      editedEmail: null,
      editedEmailCode: null,
      userName: "Bojan",
      thumbnailUrl:
        "https://storage.googleapis.com/kaggle-avatars/thumbnails/1984321-kg.jpg",
      profileUrl: "/tunguz",
      registerDate: "",
      lastVisitDate: "",
      statusId: 0,
      performanceTier: 0,
      userRoles: [],
      userLogins: [],
      groupIds: [],
      duplicateUsers: [],
      hasPhoneVerifications: false,
      failedNerdchas: 0,
      hasPendingNerdcha: false,
      deleteRequests: [],
      userAttributes: [
        {
          type: "occupation",
          value: "Data Scientist at Nvidia (Rapids.ai)",
        } as Kaggle.Sdk.Users.Models.Attribute,
        {
          type: "addressCity",
          value: "Greencastle",
        } as Kaggle.Sdk.Users.Models.Attribute,
        {
          type: "addressCountry",
          value: "United States",
        } as Kaggle.Sdk.Users.Models.Attribute,
        {
          type: "addressRegion",
          value: "Indiana",
        } as Kaggle.Sdk.Users.Models.Attribute,
      ],
      isAdmin: false,
      isKaggleBot: false,
      isAnonymous: false,
      canAct: false,
      canBeSeen: false,
      thumbnailName: null,
      isPhoneVerified: false,
      grandfatheredCompetitionTier: null,
    });
};
